
import update from 'immutability-helper';
import * as types from './types';
import * as baseTyes from '../base/types';

const initialState = {
  isFetching: true,
  hasError: false,
  searchKey: '',
  selectedSeverities: ['Total'],
  selectedMetrics: [],
  selectedTab: 'all',
  summaryData: {},
  filter: null,
  showActiveAlerts: false,
  tableSort: { key: 'eventTime', order: 'desc' }
};
const switchMap = {};

switchMap[types.INIT] = state => update(state, {
  $set: initialState,
});

switchMap[baseTyes.SET_INTERVAL] = state => update(state, {
  searchKey: { $set: '' }
});

switchMap[types.SET_SEARCH_KEY] = (state, action) => update(state, {
  searchKey: { $set: action.payload },
});

switchMap[types.SET_SELECTED_TAB] = (state, action) => update(state, {
  selectedTab: { $set: action.payload }
});

switchMap[types.FETCHING] = (state, action) => update(state, {
  isFetching: { $set: action.flag },
});

switchMap[types.SET_ERROR] = (state, action) => update(state, {
  hasError: { $set: action.flag },
});

switchMap[types.SHOW_ACTIVE_ALERTS] = (state, action) => update(state, {
  showActiveAlerts: { $set: action.flag },
});

switchMap[types.SET_SUMMARY_DATA] = (state, action) => update(state, {
  summaryData: { $set: action.payload },
});

switchMap[types.SELECT_SEVERITY] = (state, action) => update(state, {
  selectedSeverities: { $set:  selectSeverity(state.selectedSeverities, action.payload)},
});

switchMap[types.UN_SELECT_SEVERITY] = (state, action) => update(state, {
  selectedSeverities: { $set:  unSelectSeverity(state.selectedSeverities, action.payload)},
});

switchMap[types.SELECT_METRIC] = (state, action) => update(state, {
  selectedMetrics: { $set:  selectTag(state.selectedMetrics, action.payload)},
});

switchMap[types.UN_SELECT_METRIC] = (state, action) => update(state, {
  selectedMetrics: { $set:  unSelectTag(state.selectedMetrics, action.payload)},
});

switchMap[types.RESET_METRIC_SELECTION] = (state, action) => update(state, {
  selectedMetrics: { $set:  []},
});

switchMap[types.RESET_TAB_SELECTION] = (state, action) => update(state, {
  selectedSeverities: { $set:  ['Total']},
});

switchMap[types.SET_SELECTED_TAB] = (state, action) => update(state, {
  selectedTab: { $set: action.payload },
});

switchMap[types.SET_FILTER] = (state, action) => update(state, {
  filter: { $set: action.filter },
});

switchMap[types.SET_AI_ALERTS_SUMMARY_TABLE_SORT] = (state, action) => update(state, {
  tableSort: { $set: action.sortObj },
});



export default (state = initialState, action) => (switchMap[action.type]
  ? switchMap[action.type](state, action) : state);

const selectTag = (tagsArray, tag) => {
  const updatedArray = [...tagsArray, tag];
  return updatedArray;
}

const unSelectTag = (tagsArray, tag) => {
  const updatedArray = tagsArray.filter(item => item !== tag);
  return updatedArray;
}

const selectSeverity = (severityArray, severityTag) => {
  let updatedArray = [] as any;
  if (severityTag === 'Total') {
    updatedArray = ['Total']
  } else {
    updatedArray = severityArray.filter(severityTag => severityTag !== 'Total');
    updatedArray = [...updatedArray, severityTag];
  }
  return updatedArray;
}

const unSelectSeverity = (severityArray, severity) => {
  const updatedArray = severityArray.filter(item => item !== severity);
  if (updatedArray.length === 0) {
    return ['Total']
  }
  return updatedArray;
}
